module.exports = __webpack_public_path__ + "static/img/busca candidatos 1024x768.ac311f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/empleador/candidatos/busca candidatos 1024x768.jpg
// module id = 1xs9
// module chunks = 47